/**
 * Page Compositions for Corporate Multidomain Theme
 *
 * Defines both static corporate pages and template pages
 * that are instantiated per-property at build time.
 */

import { mergePages, resolvePageTokens } from '@vibesites/runtime';
import type { PageComposition } from '@vibesites/runtime';
import pagesJson from './pages.json';

const resolvedPages = mergePages(pagesJson);

export const pages: Record<string, PageComposition> = Object.fromEntries(
  resolvedPages.map(p => [p.alias, resolvePageTokens(p)])
);

export default pages;
